import { useMemo } from 'react';

const Star = ({ name, width }: { name: string; width: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <mask
      id={`mask_${name}_${width}`}
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width={width} height="16" fill="#D9D9D9" />
    </mask>
    <path
      d="M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z"
      fill="#D9D9D9"
      opacity="0.3"
    />
    <g mask={`url(#mask_${name}_${width})`}>
      <path
        d="M8 0L9.79611 5.52786H15.6085L10.9062 8.94427L12.7023 14.4721L8 11.0557L3.29772 14.4721L5.09383 8.94427L0.391548 5.52786H6.20389L8 0Z"
        fill="#46DA93"
      />
    </g>
  </svg>
);

export const StarRate = ({ ratePercent }: { ratePercent: number }) => {
  const widths = useMemo(
    () =>
      Array.from({ length: 5 }).map((_, index) =>
        Math.ceil(
          (Math.min(20, ratePercent - 20 * index < 0 ? 0 : ratePercent - 20 * index) / 20) * 16,
        ),
      ),
    [ratePercent],
  );

  return (
    <div className="flex">
      <Star name="star_0" width={widths[0]} />
      <Star name="star_1" width={widths[1]} />
      <Star name="star_2" width={widths[2]} />
      <Star name="star_3" width={widths[3]} />
      <Star name="star_4" width={widths[4]} />
    </div>
  );
};
